module.exports = __webpack_public_path__ + "static/media/custom-plan.039ed703.svg";